import _styled from "@emotion/styled-base";
import { jsx } from '@emotion/core';
import { COLORS, PADDING } from '../../constants';
import { rowHeight, columnWidth } from './constants';

var TableCell = _styled("td", {
  target: "e1r2rl940",
  label: "TableCell"
})({
  borderTop: "solid 1px " + COLORS.grays.cardBorder,
  textAlign: 'left',
  verticalAlign: 'middle',
  '&:first-of-type': {
    paddingLeft: PADDING.small
  },
  '&:last-of-type': {
    paddingRight: PADDING.small
  },
  '& > *': {
    margin: '0 !important'
  }
}, function (props) {
  return {
    whiteSpace: props.wrap ? 'normal' : 'nowrap',
    height: (props.expanded ? rowHeight.expanded : rowHeight["default"]) + "px",
    '&:first-of-type': {
      width: props.size === 'small' ? 24 + columnWidth[props.size] + "px" : 'auto'
    },
    '&:last-of-type': {
      width: props.size === 'content' ? '1%' : 'auto'
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

export var Cell = function Cell(_a) {
  var children = _a.children,
      _b = _a.size,
      size = _b === void 0 ? 'auto' : _b,
      _c = _a.expanded,
      expanded = _c === void 0 ? false : _c,
      _d = _a.wrap,
      wrap = _d === void 0 ? false : _d,
      colspan = _a.colspan,
      rowspan = _a.rowspan,
      onClick = _a.onClick,
      testId = _a["data-testid"];
  return jsx(TableCell, {
    expanded: expanded,
    size: size,
    colSpan: colspan,
    rowSpan: rowspan,
    onClick: onClick,
    wrap: wrap,
    "data-testid": testId
  }, children);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Table/Cell.js
// module id = 1253
// module chunks = 0